<style>
.page-category .item-list {
  padding-top: 30px;
  padding-bottom: 30px;
}
.page-category .item {
  position: relative;
  border-radius: 5px;
  margin-bottom: 30px;
}
.page-category .item:hover {
  background-color: rgba(15, 15, 22, 0.9);
}
.page-category .item .title {
  width: 100%;
  float: left;
  clear: both;
  position: absolute;
  z-index: 10;
  left: 0;
  bottom: 10px;
  padding: 34px 50px 36px;
  box-sizing: border-box;
}
.page-category .item .title h3 {
  margin: 0 0 10px;
  padding: 0;
  font-size: 24px;
  letter-spacing: 0;
  font-weight: 300;
}
.page-category .item .title h3 a {
  color: #eee;
  text-decoration: none;
}
.page-category .item .title p a {
  position: relative;
  display: inline-block;
  text-transform: uppercase;
  color: #d24e1a;
  font-weight: 600;
  letter-spacing: 0;
  font-size: 14px;
  line-height: 18px;
  padding-right: 25px;
  text-decoration: none;
}
.page-category .item .title p {
  margin: 0;
  padding: 0;
  line-height: 1;
}
.page-category .item .title img,
.page-category .item .title svg {
  width: 15px;
  height: 15px;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -7px;
}
.page-category .item:after {
  left: 30px;
  right: 30px;
  height: 10px;
  bottom: -10px;
  background-color: #d24e1a;
  content: "";
  position: absolute;
  z-index: -1;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.page-category .item .img_holder img,
.page-category .item .img_holder a {
  border-radius: 5px;
  height: 262px;
}
.page-category .item .img_holder a {
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;
}
.page-category .item:hover .img_holder a {
  background-color: rgba(0, 0, 0, 0.9);
}
.page-category .item .img_holder a:before {
  left: 50px;
  top: 49px;
  width: 0;
  height: 2px;
  transition-delay: 0.3s;
  content: "";
  background-color: #d24e1a;
  position: absolute;
  z-index: 22;
  transition: all 0.3s ease;
}
.page-category .item:hover .img_holder a:before {
  width: 20px;
}
.page-category .item .img_holder a:after {
  left: 59px;
  top: 40px;
  width: 2px;
  height: 0;
  content: "";
  background-color: #d24e1a;
  position: absolute;
  z-index: 22;
  transition: all 0.3s ease;
}
.page-category .item:hover .img_holder a:after {
  height: 20px;
}
.page-category .title_holder {
  position: relative;
  padding: 95px 0 35px;
  width: 100%;
  float: left;
  clear: both;
}
.page-category .title_holder:before {
  bottom: 13px;
  width: 150px;
  border-radius: 10px;
}
.page-category .title_holder:after {
  bottom: 0;
  width: 70px;
  border-radius: 10px;
}
.page-category .title_holder:before,
.page-category .title_holder:after {
  left: 0;
  position: absolute;
  height: 6px;
  background-color: #eee;
  content: "";
}
.page-category .title_holder .breadcrumbs {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  padding-top: 13px;
  padding-bottom: 2px;
}
.page-category .title_holder .breadcrumbs ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.page-category .title_holder .breadcrumbs li {
  float: left;
  margin-bottom: 5px;
}
.page-category .title_holder .breadcrumbs li a {
  font-size: 14px;
  color: #666;
  text-decoration: none;
  letter-spacing: 0;
  line-height: 1.5;
  font-weight: 600;
}
.page-category .title_holder .breadcrumbs .separator span {
  width: 33px;
  height: 24px;
  display: block;
  position: relative;
}
.page-category .title_holder .breadcrumbs .separator span:after,
.page-category .title_holder .breadcrumbs .separator span:before {
  width: 9px;
  height: 2px;
  display: block;
  position: absolute;
  background-color: #ddd;
  left: 13px;
  content: "";
}
.page-category .title_holder .breadcrumbs .separator span:before {
  top: 14px;
  transform: rotate(135deg);
}
.page-category .title_holder .breadcrumbs .separator span:after {
  top: 8px;
  transform: rotate(45deg);
}
</style>
<template>
  <div class="page-category">
    <div class="container">
      <div class="title_holder">
        <h3>{{ $t("nav.projects") }}</h3>
        <div class="breadcrumbs">
          <ul>
            <li class="item-home">
              <router-link class="bread-link bread-home" to="/" title="Home">{{
                $t("nav.main")
              }}</router-link>
            </li>
            <li class="separator separator-home">
              <span></span>
            </li>
            <li class="item-current">
              <span class="bread-current">{{ $t("nav.projects") }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="item-list">
        <div class="row">
          <template v-for="item in $store.state.GlobalData.projects">
            <div class="col-md-4" v-if="item.status === 1" :key="item.id">
              <div class="item have_img">
                <div class="img_holder">
                  <img :src="item.images[0]" />
                  <router-link
                    :to="`/` + locale + `/project/${item.id}`"
                    :item="item"
                  ></router-link>
                </div>
                <div class="title">
                  <h3>
                    <router-link
                      :to="`/` + locale + `/project/${item.id}`"
                      :item="item"
                      >{{ item.name[locale] }}</router-link
                    >
                  </h3>
                  <p>
                    <router-link
                      class="view_more"
                      :to="`/` + locale + `/project/${item.id}`"
                      :item="item"
                    >
                      <span class="text">{{ $t("more") }}</span>
                      <span class="arrow">
                        <img src="../assets/images/right-arrow-1.svg" />
                      </span>
                    </router-link>
                  </p>
                  <router-link
                    class="hover_link"
                    :to="`/` + locale + `/project/${item.id}`"
                    :item="item"
                  ></router-link>
                </div>
              </div>
            </div>
          </template>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locale: this.$route.params.locale,
    };
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    },
  },
};
</script>
